import { render } from "./sentence.vue?vue&type=template&id=60d2440c&scoped=true"
import script from "./sentence.vue?vue&type=script&lang=js"
export * from "./sentence.vue?vue&type=script&lang=js"

import "./sentence.vue?vue&type=style&index=0&id=60d2440c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d2440c"]])

export default __exports__